import { render } from "./ThirdPartyAddEdit.vue?vue&type=template&id=4725cc6c&scoped=true&ts=true"
import script from "./ThirdPartyAddEdit.vue?vue&type=script&lang=ts"
export * from "./ThirdPartyAddEdit.vue?vue&type=script&lang=ts"

import "./ThirdPartyAddEdit.vue?vue&type=style&index=0&id=4725cc6c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4725cc6c"]])

export default __exports__